interface Result {
  data: any[]
  meta: any
}

export function usePaginator(
  getResults: (page: number, ...args: any) => Promise<Result>,
  key: string = 'paginator',
) {
  const results = useState(`${key}-results`, () => [])
  const meta = useState(`${key}-meta`, () => ({}))
  const page = useState(`${key}-page`, () => 0)
  const savedArgs = useState(`${key}-args`, () => [])
  const isLoading = useState(`${key}-isLoading`, () => false)
  const isStarted = useState(`${key}-isStarted`, () => false)

  const setPaginator = async (...args: any) => {
    results.value = []
    page.value = 0
    meta.value = {}
    savedArgs.value = args
    return await next()
  }

  async function start(...args: any) {
    isStarted.value = true
    return await setPaginator(...args)
  }

  async function reset(...args: any) {
    if (!isStarted.value) return
    return await setPaginator(...args)
  }

  async function next(infiniteLoader = null) {
    if (isLoading.value) return
    isLoading.value = true
    page.value++
    const { data, meta: resultMeta } = await getResults(
      page.value,
      ...savedArgs.value,
    )
    meta.value = resultMeta
    results.value = page.value !== 1 ? [...results.value, ...data] : data

    if (infiniteLoader) {
      if (data.length === 0) {
        infiniteLoader?.complete()
      } else {
        infiniteLoader?.loaded()
      }
    }

    isLoading.value = false
    return data
  }

  return { start, next, reset, results, meta }
}
